import React from 'react'
import { ambient } from '@aw_products/ambient-weather-common'
import { useParams } from 'react-router-dom'
import { HsThreshold } from './'
const { HST } = ambient
// import PropTypes from 'prop-types';

export default function HeatStressGuidelines () {
  const { guideline, zone, level } = useParams()

  let title = 'Heat Stress Guidelines'
  let show = null
  console.log('HST', HST, guideline, zone, level)
  if (guideline) {
    let guide = HST.guidelines[guideline]
    if (guide) {
      title = guide.label
      if (level) {
        guide = guide.guidelines.find(g => g.label === level)
        title += ` - ${guide.label}`
      } else {
        guide = guide.guidelines[0]
      }
      const z = zone && guide.zones.find(z => z.label === zone)
      if (z) {
        show = (
          <div>
            <HsThreshold zone={z} guideline={guide} />
            <a href={guide.source} target='_blank' rel='noopener noreferrer'>Learn more</a>
          </div>
        )
      } else {
        show = (
          <div className='guideline'>
            {guide.zones.map(z => (
              <HsThreshold key={z.label} zone={z} guideline={guide} />
            ))}
          </div>
        )
      }
    }
  }


  return (
    <div className='device-heat-stress-guidelines'>
      <header className='main'>
        <h1>
          {title}
        </h1>
      </header>
      {show && (
        <div className='block'>{show}</div>
      )}
    </div>
  )
};

HeatStressGuidelines.propTypes = {}
HeatStressGuidelines.defaultProps = {}

HeatStressGuidelines.displayName = 'HeatStressGuidelines'
